import axios from "./axios";

export async function deleteOrder(payload) {
  return axios
    .delete(`/orders/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createOrder(payload) {
  return axios
    .post(`/orders/`, { order: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Return error object with proper structure for Redux Toolkit to handle
      if (error.response) {
        // Server responded with error status
        return Promise.reject({
          response: {
            status: error.response.status,
            data: error.response.data,
          },
          message: error.message,
        });
      } else if (error.request) {
        // Request was made but no response received
        return Promise.reject({
          response: {
            status: 0,
            data: { error: "No response from server" },
          },
          message: "Network error",
        });
      } else {
        // Something else happened
        return Promise.reject({
          response: {
            status: 500,
            data: { error: error.message },
          },
          message: error.message,
        });
      }
    });
}

export async function updateOrder(payload) {
  return axios
    .put(`/orders/` + payload.id, { order: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Return error object with proper structure for Redux Toolkit to handle
      if (error.response) {
        // Server responded with error status
        return Promise.reject({
          response: {
            status: error.response.status,
            data: error.response.data,
          },
          message: error.message,
        });
      } else if (error.request) {
        // Request was made but no response received
        return Promise.reject({
          response: {
            status: 0,
            data: { error: "No response from server" },
          },
          message: "Network error",
        });
      } else {
        // Something else happened
        return Promise.reject({
          response: {
            status: 500,
            data: { error: error.message },
          },
          message: error.message,
        });
      }
    });
}

export async function fetchOrder(payload) {
  // payload is only ID
  return axios
    .get(`/orders/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchStripeSession(order_id) {
  // payload is only ID
  return axios
    .get(`/orders/` + order_id + "/stripe_session")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function sendStripePaymentLink(order_id) {
  return axios
    .post(`/payments/create_manual`, {
      order_id,
      payment_method: "stripe",
    })
    .then((response) => {
      return response.data;
    });
}

export async function fetchOrders(controller) {
  return axios({ method: "get", url: "/orders/list", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function sendOffer(payload) {
  return axios
    .post(`/orders/${payload.id}/send_offer`, { offer: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function getPdfOffer(payload) {
  return axios
    .get(`/orders/${payload.id}/pdf_offer`, { params: payload.params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function checkSendOfferStatus(jobId) {
  return axios
    .get(`/orders/send_offer_status/${jobId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
